import { useState } from 'react';
// @mui
import { Link, Stack, IconButton, InputAdornment, TextField, Checkbox, MenuItem, InputLabel } from '@mui/material';
import { LoadingButton } from '@mui/lab';
import FormControl from '@mui/material/FormControl';
import Select, { SelectChangeEvent } from '@mui/material/Select';

import api from '../../../api';
import { loadingStartAction } from 'src/redux/actions/loadingActions';
import { useDispatch } from 'react-redux';

// components

// ----------------------------------------------------------------------

export default function GameTypeForm({ handleClose, selectedGame }) {
    const dispatch = useDispatch();
  // States for input fields
  const [gameName, setGameName] = useState(selectedGame?.game_type_name || '');
  const [gameUniqueId, setGameUniqueId] = useState(selectedGame?.game_type_unique_id || '');

  const handleGameCreate = async () => {
    const reqBody = {
      game_type_name: gameName,
      game_type_unique_id: gameUniqueId,
      is_active: true,
    };

    if(!reqBody.game_type_unique_id || !reqBody.game_type_name){
      return
    }
    handleClose();
    dispatch(loadingStartAction())
    if (selectedGame) {
      await api.put(`/game-types/${selectedGame._id}`, reqBody);
    } else {
      await api.post('/game-types', reqBody);
    }
   
    window.location.reload()
  };

  return (
    <>
      <Stack spacing={3} my={2}>
        <TextField name="game_name" label="Game Name" value={gameName} onChange={(e) => setGameName(e.target.value)} />

        <FormControl fullWidth>
          <InputLabel id="demo-simple-select-label">Select Game Type</InputLabel>
          <Select
            labelId="demo-simple-select-label"
            id="demo-simple-select"
            value={gameUniqueId}
            label="Select Game Type"
            onChange={(e) => setGameUniqueId(e.target.value)}
          >
            {[1,2,3,4,5,6,7,8]?.map((item) => {
              return (
                <MenuItem key={item} value={item}>
                  {item}
                </MenuItem>
              );
            })}
          </Select>
        </FormControl>

      </Stack>



      <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ my: 2 }}>
        {/* <Checkbox
          name="remember"
          checked={rememberMe}
          onChange={(e) => setRememberMe(e.target.checked)}
          label="Remember me"
        /> */}
      </Stack>

      <LoadingButton fullWidth size="large" type="submit" variant="contained" onClick={handleGameCreate}>
        {selectedGame ? 'Update' : 'Create New'}
      </LoadingButton>
    </>
  );
}
